import { useCallback, useState } from 'react';

interface Props {
  defaultValue?: string;
}

export default function useInputValue(props?: Props) {
  const [value, setValue] = useState(props?.defaultValue ?? '');

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      setValue(event.target.value),
    []
  );

  return { value, setValue, handleChange };
}
